const $ = window.$
export const toggleModalById = (id, status) => {
    if (id)
        $(`#${id}`).modal(status ? 'show' : 'hide');
    if (!status)
        $('.modal-backdrop').remove();
}
export const toggleModalByIdKey = (id, status) => {
    if (id)
    // $(`#${id}`).modal(status?'show':'hide');
        $(`#${id}`).modal({
        backdrop: 'static',
        keyboard: false
    })
    if (!status) {
        $(`#${id}`).modal(status ? 'show' : 'hide');
        $('.modal-backdrop').remove();
    }


}


export const toggleSidebar = () => {
    return $(document).on('click', '#toggle_btn', function() {
        if ($('body').hasClass('mini-sidebar')) {
            $('body').removeClass('mini-sidebar');
            $('.subdrop + ul').slideDown();
        } else {
            $('body').addClass('mini-sidebar');
            $('.subdrop + ul').slideUp();
        }
        return false;
    });
}

export const loadCustomJquery = () => {
    return $(document).ready(function() {


        // // Variables declarations
        // $("#toggle_btn").click(function() {
        //     $("body").toggleClass("hide-sidebar-p");
        // });

        var $wrapper = $('.main-wrapper');
        var $pageWrapper = $('.page-wrapper');

        // Sidebar

        // var Sidemenu = function() {
        //     this.$menuItem = $('#sidebar-menu a');
        // };

        function init() {


            $('#sidebar-menu a').on('click', function(e) {
                console.log("clicking on a");
                if ($(this).parent().hasClass('submenu')) {
                    e.preventDefault();
                }
                if (!$(this).hasClass('subdrop')) {
                    $('ul', $(this).parents('ul:first')).slideUp(350);
                    $('a', $(this).parents('ul:first')).removeClass('subdrop');
                    $(this).next('ul').slideDown(350);
                    $(this).addClass('subdrop');
                } else if ($(this).hasClass('subdrop')) {
                    $(this).removeClass('subdrop');
                    $(this).next('ul').slideUp(350);
                }
            });
            $('#sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');

        }


        // Sidebar Initiate
        init();

        // Mobile menu sidebar overlay

        $('body').append('<div class="sidebar-overlay"></div>');
        $(document).on('click', '#mobile_btn', function() {
            $wrapper.toggleClass('slide-nav');
            $('.sidebar-overlay').toggleClass('opened');
            $('html').addClass('menu-opened');
            $('#task_window').removeClass('opened');
            return false;
        });

        $(".sidebar-overlay").on("click", function() {
            $('html').removeClass('menu-opened');
            $(this).removeClass('opened');
            $wrapper.removeClass('slide-nav');
            $('.sidebar-overlay').removeClass('opened');
            $('#task_window').removeClass('opened');
        });



        // Modal Popup hide show

        if ($('.modal').length > 0) {
            var modalUniqueClass = ".modal";
            $('.modal').on('show.bs.modal', function(e) {
                var $element = $(this);
                var $uniques = $(modalUniqueClass + ':visible').not($(this));
                if ($uniques.length) {
                    $uniques.modal('hide');
                    $uniques.one('hidden.bs.modal', function(e) {
                        $element.modal('show');
                    });
                    return false;
                }
            });
        }

        // Floating Label

        if ($('.floating').length > 0) {
            $('.floating').on('focus blur', function(e) {
                $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
            }).trigger('blur');
        }

        // Sidebar Slimscroll


        // Page Content Height

        var pHeight = $(window).height();
        $pageWrapper.css('min-height', pHeight);
        $(window).resize(function() {
            var prHeight = $(window).height();
            $pageWrapper.css('min-height', prHeight);
        });










        // Small Sidebar

        $(document).on('click', '#toggle_btn', function() {
            if ($('body').hasClass('mini-sidebar')) {
                $('body').removeClass('mini-sidebar');
                $('.subdrop + ul').slideDown();
            } else {
                $('body').addClass('mini-sidebar');
                $('.subdrop + ul').slideUp();
            }
            return false;
        });

        $(document).on('mouseover', function(e) {
            e.stopPropagation();
            if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                var targ = $(e.target).closest('.sidebar').length;
                if (targ) {
                    $('body').addClass('expand-menu');
                    $('.subdrop + ul').slideDown();
                } else {
                    $('body').removeClass('expand-menu');
                    $('.subdrop + ul').slideUp();
                }
                return false;
            }
        });

        $(document).on('click', '.top-nav-search .responsive-search', function() {
            $('.top-nav-search').toggleClass('active');
        });

        $(document).on('click', '#file_sidebar_toggle', function() {
            $('.file-wrap').toggleClass('file-sidebar-toggle');
        });

        $(document).on('click', '.file-side-close', function() {
            $('.file-wrap').removeClass('file-sidebar-toggle');
        });
        // light view js
        $(document).on('click', '.dark-view', function() {
            $("body").toggleClass("light-view");
        });

        $(document).on('click', '#sidebar-hide-toggle', function() {
            $('body').toggleClass('hide-sidebar-p');
        });

        if ($('.kanban-wrap').length > 0) {
            $(".kanban-wrap").sortable({
                connectWith: ".kanban-wrap",
                handle: ".kanban-box",
                placeholder: "drag-placeholder"
            });
        }

    });

}

export const loadSlimScrollCustomJs = () => {
    var $slimScrolls = $('.slimscroll');

    if ($slimScrolls.length > 0) {
        $slimScrolls.slimScroll({
            height: 'auto',
            width: '100%',
            position: 'right',
            size: '7px',
            color: '#ccc',
            wheelStep: 10,
            touchScrollStep: 100
        });
        var wHeight = $(window).height() - 60;
        $slimScrolls.height(wHeight);
        $('.sidebar .slimScrollDiv').height(wHeight);
        $(window).resize(function() {
            var rHeight = $(window).height() - 60;
            $slimScrolls.height(rHeight);
            $('.sidebar .slimScrollDiv').height(rHeight);
        });
    }


}

export const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}
export const zoomInzoomOut=()=>{
    // const handleWheel = function(e) {
    //     if(e.ctrlKey || e.metaKey)
    //         e.preventDefault();
    // };
    // window.addEventListener("wheel", handleWheel, {passive: false});

    // $(document).keydown(function(event) {
    //     if (event.ctrlKey==true && (event.which == '61' || event.which == '107' || event.which == '173' || event.which == '109' || event.which == '187' || event.which == '189' ) ) {
    //     event.preventDefault();
    //     }
    //     // 107 Num Key +
    //     // 109 Num Key -
    //     // 173 Min Key hyphen/underscor Hey
    //     // 61 Plus key +/= key
    //     });
    //     $(window).bind('mousewheel DOMMouseScroll', function (event) {
    //     if (event.ctrlKey == true) {
    //     event.preventDefault();
    //     }
    //     });
}